import { wuid } from '../../../utils';
import { deviceDetect } from 'react-device-detect';

export const oAuthSignInRequest = (fetchApi) => async (dto) => {
  const uid = await wuid();
  dto.device = JSON.stringify(deviceDetect());

  return fetchApi.request('post', '/user/login', { ...dto, uid });
};
